import { useDispatch } from 'react-redux';

import { getJoinGameAction } from '../lib/game-utils/get-join-game-action';
import { redirectTo } from '../store/location/actions';

import { useCheckJoinability } from './use-check-joinability';

export const useJoinGameAction = ({ gameId, gameType, startOrderParams }) => {
  const dispatch = useDispatch();

  const {
    code,
    dependsOnMembership,
    loading,
    membershipOfferId,
    potentiallyJoinable,
  } = useCheckJoinability({
    gameType,
    gameId,
  });

  const nextStep =
    !!potentiallyJoinable &&
    getJoinGameAction({
      gameId,
      gameType,
      membershipOfferId,
      startOrderParams,
      redirectToMembership: dependsOnMembership,
    });

  const joinGame = () => dispatch(redirectTo(nextStep));

  return {
    joinabilityCode: code,
    loading,
    joinGame,
    isJoinable: !!nextStep,
    potentiallyJoinable,
  };
};
